enum VerificationType {
  VERBAL_ACCEPTANCE
  PRINTED
  PORTAL_VIEW
  PORTAL_ACCEPTANCE
  EMAIL_ACCEPTANCE
  ADVISOR_VALIDATION
  LIVENESS_PHOTO
  ID_VERIFICATION
  DEVICE_VERIFICATION
  ACRE_OVERRIDE
}

enum VerificationResult {
  VERIFICATION_RESULT_PASSED
  VERIFICATION_RESULT_SUSPECTED
  VERIFICATION_RESULT_INCONCLUSIVE
  VERIFICATION_RESULT_REJECTED
  VERIFICATION_RESULT_PENDING
  VERIFICATION_RESULT_MANUAL_REVIEW
}

enum VerificationSourceType {
  USER
  USER_ON_BEHALF_OF_CLIENT
  CLIENT
  AUTOMATED
  EQUIFAX
  ONFIDO
}

type VerificationFingerprint {
  ip: String
  user_agent: String
  referer: String
  browser_id: String
}

input DocumentVerificationInput {
  client_id: String
  document_id: String
  document_signature: String
  verification_type: VerificationType
  verification_fingerprint_browser_id: String
  source: VerificationSourceType
}

type DocumentVerification {
  id: ID!
  verification_id: String
  document_id: String
  document: DocumentEntity
  verification_date: String
  verification_type: VerificationType
  source: VerificationSourceType
  source_user_id: String
  client: Client
  client_id: String
  fingerprint: VerificationFingerprint
  document_signature: String
  signature_key_id: String
  result: VerificationResult
  result_justification: [String]

  # Extended fields so we can access the various entities via queries
  source_user: User
  source_client: Client
}

type DocumentVerificationCp {
  document_id: String
  client_id: String
  verification_type: VerificationType
  result_justification: [String!]
  verification_date: String
}

input DocumentVerificationQueryParams {
  verification_details: Boolean
  verification_ids: [String!]
  bookmark: String
  page_size: Int
}
